/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpSharedBlurbPcs_vipUserRelationship$ref = any;
export type PdpSharedBlurbPcs_vipUserRelationship = {
    readonly userDataB: ReadonlyArray<({
        readonly email?: string | null;
        readonly firstName?: string | null;
        readonly phoneNumber?: string | null;
    } & ({
        readonly email: string | null;
        readonly firstName: string | null;
        readonly phoneNumber: string | null;
    } | {
        /*This will never be '% other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    })) | null> | null;
    readonly " $refType": PdpSharedBlurbPcs_vipUserRelationship$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedBlurbPcs_vipUserRelationship",
  "type": "UserRelationship",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "userDataB",
      "storageKey": null,
      "args": null,
      "concreteType": null,
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "type": "VipRepData",
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "email",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "firstName",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "phoneNumber",
              "args": [
                {
                  "kind": "Literal",
                  "name": "formatType",
                  "value": "INTERNATIONAL"
                }
              ],
              "storageKey": "phoneNumber(formatType:\"INTERNATIONAL\")"
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '75d6797cc32e34de4cad92d01b24d960';
export default node;
